import { jsxs as o, jsx as v } from "react/jsx-runtime";
const s = (l) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ v(
        "path",
        {
          fill: "#0866FF",
          d: "M22.075 12.249c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 4.69 3.229 8.624 7.584 9.705v-6.65H7.597v-3.056H9.66v-1.316c0-3.404 1.54-4.981 4.882-4.981.634 0 1.727.124 2.174.248v2.77a13 13 0 0 0-1.155-.037c-1.64 0-2.273.62-2.273 2.236v1.08h3.266l-.561 3.056h-2.705v6.871c4.951-.598 8.788-4.814 8.788-9.926"
        }
      ),
      /* @__PURE__ */ v(
        "path",
        {
          fill: "#fff",
          d: "m15.992 15.304.561-3.056h-3.266v-1.08c0-1.615.633-2.236 2.273-2.236.51 0 .92.012 1.155.037V6.2c-.447-.124-1.54-.249-2.174-.249-3.341 0-4.882 1.578-4.882 4.982v1.316H7.597v3.056H9.66v6.65a10 10 0 0 0 3.628.221v-6.87z"
        }
      )
    ]
  }
);
export {
  s as default
};
